import { render, staticRenderFns } from "./RoomsAll.vue?vue&type=template&id=535282d0"
import script from "./RoomsAll.vue?vue&type=script&lang=js"
export * from "./RoomsAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports